<template>
    <div class="tabModuleNav tblr_spacing horizontal_layout" style="padding-bottom: 0;">
        <!-- <section class="rm_spacing" v-for="(item, index) in navData" :key="index" :class="{ active: index === navIndex }">
            <el-button @click="tabChange(item, index)">{{ item.title }} <span v-if="item.number > 0">({{ item.number }})</span></el-button>
        </section> -->
        <slot name="content"></slot>
    </div>
</template>

<script>
export default {
    props: {
        navData: {
            type: Array,
            default: () => {
                return [];
            }
        },
        navIndex: {
            type: Number,
            default: 0,
        }
    },
    data() {
        return {}
    },
    methods: {
        tabChange(item, index) {
            this.$emit('tabChange', item, index);
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/module/tabModule/index.vue